export default __webpack_public_path__ + "static/media/63c9283406ecda30.a0820beab369e2dbb0c699b7d445eb47.svg";